<div class="roadmap-container">
  @if (isEmpty && !isAddingSection) {
    <div class="empty-state">
      <pdq-icon icon="bookmark" size="large" color="iris"></pdq-icon>
      <pdq-heading element="h6">No saved strategies yet</pdq-heading>
      <p class="empty-state__description">
        Browse the strategy catalog and click the bookmark icon to save strategies to your roadmap.
      </p>
    </div>
  } @else {
    <div cdkDropListGroup class="sections-list">
      @if (defaultSectionView) {
        <roadmap-section
          [section]="defaultSectionView.section"
          [strategies]="defaultSectionView.strategies"
          [connectedDropLists]="connectedDropLists"
          (strategyClicked)="onStrategyClicked($event)"
          (strategyRemoved)="onStrategyRemoved($event)"
          (orderChanged)="onOrderChanged($event)"
          (strategyTransferred)="onStrategyTransferred($event)">
        </roadmap-section>
      }
      <div
        class="custom-sections-list"
        cdkDropList
        [cdkDropListData]="customSectionViews"
        [cdkDropListEnterPredicate]="sectionDropPredicate"
        (cdkDropListDropped)="onSectionDrop($event)">
        @for (sv of customSectionViews; track sv.section.id) {
          <roadmap-section
            cdkDrag
            [section]="sv.section"
            [strategies]="sv.strategies"
            [connectedDropLists]="connectedDropLists"
            (strategyClicked)="onStrategyClicked($event)"
            (strategyRemoved)="onStrategyRemoved($event)"
            (sectionDeleted)="onSectionDeleted($event)"
            (sectionRenamed)="onSectionRenamed($event)"
            (orderChanged)="onOrderChanged($event)"
            (strategyTransferred)="onStrategyTransferred($event)">
          </roadmap-section>
        }
      </div>
    </div>
  }

  @if (isAddingSection) {
    <div class="add-section-input-container" (keydown)="onAddSectionKeydown($event)">
      <pdq-input
        size="medium"
        placeholder="Section name..."
        [control]="newSectionControl"
        [autofocus]="true"
        (blur)="confirmAddSection()">
      </pdq-input>
    </div>
  } @else {
    <pdq-button label="+ Add Section" variant="ghost" size="small" [fullWidth]="true" (onClick)="startAddingSection()">
    </pdq-button>
  }
</div>
